import {HttpClient} from '@angular/common/http';
import {inject, Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {catchError, tap} from 'rxjs/operators';
import {environment} from '../../../../environments/environment';
import {PagedResult} from 'bs-components';
import {TranslateService} from '@ngx-translate/core';
import {MessageHandlerService} from '../messageHandler.service';
import {BinLocation, BinLocationLight, BinLocationRequest} from '../../models/storage/bin.model';

@Injectable({
  providedIn: 'root'
})
export class BinLocationService {
  private readonly http = inject(HttpClient);
  private readonly messageService = inject(MessageHandlerService);
  private readonly translate = inject(TranslateService);

  private readonly serviceUrl: string = environment.baseUrl + '/storage/bins';

  public getAll(params?: any): Observable<PagedResult<BinLocationLight>> {
    return this.http
      .get<PagedResult<BinLocationLight>>(this.serviceUrl, {params: {...params}})
      .pipe(
        catchError(this.messageService.handleError<PagedResult<BinLocationLight>>('Error loading bin locations'))
      );
  }

  public getById(id: number): Observable<BinLocation> {
    return this.http
      .get<BinLocation>(`${this.serviceUrl}/${id}`)
      .pipe(
        catchError(this.messageService.handleError<BinLocation>('Error loading bin location'))
      );
  }

  public update(id: number, body: BinLocationRequest): Observable<BinLocation> {
    return this.http.put<BinLocation>(`${this.serviceUrl}/${id}`, body).pipe(
      tap(() => {
        this.messageService.log(
          'validation',
          this.translate.instant('LOGS.BINS.UPDATE_SUCCESS'),
          1
        );
      }),
      catchError(
        this.messageService.handleError<BinLocation>('Error updating bin location')
      )
    );
  }


}
